import general from './general/main'
import loginProviders from './loginProviders/main'
import bots from './bots/main'
import organisations from './organisations/main'
import users from './users/main'

export default {
    selected: 'Ausgewählt',

    general,
    users,
    organisations,
    loginProviders,
    bots,
}